export const PIERCINGS = ['Facial Piercings', 'Body Piercings', 'Ear Gauges'];
